import React from 'react';

import PanelHome from 'panels/home/PanelHome';

export default function LayoutHome() {
    return (
        <div className='h-screen w-full'>
            <PanelHome />
        </div>
    )
}
